import { Transition } from '@headlessui/react';
import { ChevronDownMini } from '@medusajs/icons';
import { clx } from '@medusajs/ui';
import { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMobileNav } from './context';

export type NavItemType = {
  title: string;
  href?: string;
  childItems?: NavItemType[];
  className?: string;
  'data-testid'?: string;
};

const NavItem = (props: NavItemType) => {
  const { title, childItems, className, 'data-testid': testId } = props;
  const navigate = useNavigate();
  const { closeDrawer: closeNav } = useMobileNav();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => setIsExpanded((prev) => !prev);

  const handleItemClick = (item: NavItemType) => {
    if (item.href) {
      closeNav();
      navigate(item.href);
    } else if (item.childItems && item.childItems.length > 0) {
      toggleExpanded();
    }
  };

  return (
    <>
      <div
        onClick={() => handleItemClick(props)}
        className={clx(
          'text-black-10 flex min-h-10 items-center justify-between',
          className
        )}
        data-testid={testId}
      >
        <div>{title}</div>
        {childItems && childItems.length > 0 && (
          <ChevronDownMini
            onClick={(e) => {
              e.stopPropagation();
              toggleExpanded();
            }}
            className={clx('transition-all duration-300 ease-in-out', {
              'rotate-180': isExpanded,
            })}
          />
        )}
      </div>
      <Transition
        as={Fragment}
        leave="transition-all ease-in-out duration-300"
        leaveFrom="opacity-100 h-full"
        leaveTo="opacity-50 h-0"
        show={isExpanded}
      >
        <div className="flex flex-col gap-1">
          {childItems?.map((item) => (
            <div key={item.title} onClick={() => handleItemClick(item)}>
              <NavItem {...item} className="text-grey-60" />
            </div>
          ))}
        </div>
      </Transition>
    </>
  );
};

export default NavItem;
